import { Subscription } from 'rxjs';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { ForgotPasswordForm } from '@optsolservices/ngx-forgot-password-form';
import { NotificationService } from '@optsolservices/ngx-notification';
import { EnvironmentSettings } from '../../models/environment-settings';
import { AuthService } from '../../services/auth.service';
import { GeneralStoreService } from '../../store/general.store';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  public environmentSettings: EnvironmentSettings;
  private envSubscription: Subscription;

  constructor(
    private authService: AuthService,
    private notificationService: NotificationService,
    private generalStoreService: GeneralStoreService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.envSubscription = this.generalStoreService.getEnvironmentSettings().subscribe(es => this.environmentSettings = es);
  }

  ngOnDestroy(): void {
    if (this.envSubscription) { this.envSubscription.unsubscribe(); }
  }

  async submit(forgotPasswordForm: ForgotPasswordForm): Promise<void> {
    const response = await this.authService.userPasswordChangeRequest(forgotPasswordForm.email).toPromise();
    if (response.responseCode !== 0) { return; }
    this.notificationService.success('An email has been sent with instructions on how to reset your password.');
    this.router.navigate(['/']);
  }
}
